<template></template>
<script>
export default {
  name: "Cadastro",
  data() {
    return {
    };
  },
  created(){
    this.$router.push("/clube/register-instituicao");
  }
};
</script>